import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
  Button,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Menu,
  CardHeader,
  Card,
  CardContent,
  Box, CircularProgress,
  Radio,
  RadioGroup,
  FormControlLabel,
  Modal,
  IconButton,
  Typography,
  Grid,
  TablePagination,
} from "@mui/material";
import ExcelJS from "exceljs";
import jsPDF from "jspdf"; // For PDF export
import "jspdf-autotable"; // For PDF table generation
import PresentToAllIcon from "@mui/icons-material/PresentToAll";
import SimCardDownloadIcon from "@mui/icons-material/SimCardDownload";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import FilePresentIcon from "@mui/icons-material/FilePresent";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";

import { useNavigate } from "react-router-dom";
import { GlobalStyles } from "@mui/system";
import { useAuth } from "../../../../AuthProvider";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DeleteIcon from "@mui/icons-material/Delete";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Swal from "sweetalert2";
import { useLocation } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import { Formik, Form, Field, ErrorMessage } from "formik";

import * as Yup from "yup";

const baseUrl = process.env.REACT_APP_API_BASE_URL;

const StockItemsMaterialReports = () => {
  const [items, setItems] = useState([]); // Track the list of items from the backend
  const [openModal, setOpenModal] = useState(false); // Modal state
  const [isLoading, setIsLoading] = useState(false);
  const { userId, oId,role ,pId} = useAuth();
  const [isSubmittingEdit, setIsSubmittingEdit] = useState(false);
  const [deletingItemId, setDeletingItemId] = useState(null);
  const navigate = useNavigate(); 

  //search fields
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [categoryOptions, setCategoryOptions] = useState([]);

  const [ItemId, setItemId] = useState("");
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [editData, setEditData] = useState({}); // to hold the data for editing

  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState('');
  const isPrincipal = role?.startsWith("PRINCIPAL") || false;
  const UserId = userId || selectedUsers;



  const [exportAnchorEl, setExportAnchorEl] = useState(null);
  const isExportMenuOpen = Boolean(exportAnchorEl);

  // State to capture form input values
  const [newItem, setNewItem] = useState({
    items: "",
    // hsn: "",
    qty: "",
    priceItem: "",
    // discount: "",
    // category: "",
    description: "",
    // tax: "",
    measureUnits: "",
  });





  // Fetch items by form ID
  const fetchItemsStockItems = async () => {
    setIsLoading(true); // Start loading before fetching
    try {
      const response = await fetch(
        `${baseUrl}/api/itemstable/pr/getAllItems/${oId}/${pId}`
      );
      if (response.ok) {
        const itemsData = await response.json();
        // const sortedData=itemsData.sort((a, b) => new Date(b.invoiceDate) - new Date(a.invoiceDate));
        setItems(itemsData); // Set the fetched items to the state

        console.log("Items fetched successfully");

        // Extract unique categories
        const uniqueCategories = [
          ...new Set(itemsData.map((item) => item.category)),
        ];
        setCategoryOptions(uniqueCategories);
      } else {
        console.error("Failed to fetch items");
      }
    } catch (error) {
      console.error("Error fetching items:", error);
    } finally {
      setIsLoading(false); // Stop loading after fetch is done
    }
  };

  useEffect(() => {
    fetchItemsStockItems(); // Fetch items by form ID
  }, []);

 

  const handleDelete = async (item) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: `You want to delete "${item.items}" Item From the Stock`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      setDeletingItemId(item.itId); // Start loading

      try {
        const response = await fetch(
          `${baseUrl}/api/itemstable/deleteItems/${item.itId}/${oId}`,
          {
            method: "DELETE",
          }
        );

        if (response.ok) {
          toast.success("Item deleted successfully!", { autoClose: 1000 });
          fetchItemsStockItems();
        } else {
          toast.error("Failed to delete Item.");
        }
      } catch (error) {
        console.error("Error deleting item:", error);
        toast.error("Error deleting Item.");
      } finally {
        setDeletingItemId(null); // Stop loading
      }
    }
  };

  //search functionality
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleCategoryChange = (e) => {
    setSelectedCategory(e.target.value);
  };

  const filteredItems = items.filter(
    (item) =>
      item.items.toLowerCase().includes(searchQuery.toLowerCase()) &&
      (selectedCategory ? item.category === selectedCategory : true)
  );
  // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);



  const handleExportClick = (event) => {
    setExportAnchorEl(event.currentTarget);
  };

  const handleExportClose = () => {
    setExportAnchorEl(null);
  };

  const exportToExcel = () => {
  const filteredData = filteredItems.map(
    ({ items, hsn, qty, measureUnits, description, priceItem }, index) => ({
      index: index + 1,
      items,
      qty,
      measureUnits,
      description,
      priceItem: Number(priceItem) || 0,
    })
  );

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(`StockItems_Reports`);

  worksheet.columns = [
    { header: "S.No", key: "index", width: 8 },
    { header: "Item Name", key: "items", width: 20 },
    { header: "Quantity", key: "qty", width: 10 },
    { header: "Measure Units", key: "measureUnits", width: 15 },
    { header: "Description", key: "description", width: 20 },
    { header: "Amount", key: "priceItem", width: 15 },
  ];

  // Add data rows
  filteredData.forEach((data) => {
    worksheet.addRow({
      ...data,
      priceItem: `${data.priceItem.toLocaleString("en-IN")}`,
    });
  });

  // Style header
  worksheet.getRow(1).eachCell((cell) => {
    cell.font = { bold: true };
    cell.alignment = { horizontal: "center" };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "87CEEB" }, // Sky blue
    };
    cell.border = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };
  });

  // Optional: Add total amount row at the end
  const totalAmount = filteredData.reduce((sum, row) => sum + row.priceItem, 0);
  const totalRowIndex = worksheet.lastRow.number + 1;
  const totalRow = worksheet.addRow([]);

  worksheet.mergeCells(`A${totalRowIndex}:E${totalRowIndex}`);
  const labelCell = totalRow.getCell(1);
  labelCell.value = "Total Amount";
  labelCell.font = { bold: true };
  labelCell.alignment = { horizontal: "center" };
  labelCell.fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "FFFACD" },
  };
  labelCell.border = {
    top: { style: "thin" },
    bottom: { style: "thin" },
    left: { style: "thin" },
    right: { style: "thin" },
  };

  const amountCell = totalRow.getCell(6);
  amountCell.value = `₹${totalAmount.toLocaleString("en-IN")}`;
  amountCell.font = { bold: true };
  amountCell.alignment = { horizontal: "center" };
  amountCell.fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "FFFACD" },
  };
  amountCell.border = {
    top: { style: "thin" },
    bottom: { style: "thin" },
    left: { style: "thin" },
    right: { style: "thin" },
  };

  // Generate and download the Excel file
  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `StockItems_Reports.xlsx`;
    link.click();
  });

  handleExportClose();
};


 const exportToPDF = () => {
  const doc = new jsPDF();

  // Title
  doc.setFontSize(16);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(0, 0, 0);
  doc.text("Stock Items Reports", 10, 8);

  // Prepare table data and calculate total
  let totalAmount = 0;

  const tableData = filteredItems.map((row, index) => {
    const amount = Number(row.priceItem) || 0;
    totalAmount += amount;

    return [
      index + 1,
      row.items || "N/A",
      row.qty || "N/A",
      row.measureUnits || "N/A",
      row.description || "N/A",
      {
        content: `${amount.toLocaleString("en-IN")}`,
        styles: {
          fontStyle: "bold",
          textColor: [0, 128, 0], // Green
        },
      },
    ];
  });

  // Add total row at the end
  tableData.push([
    {
      content: "Total Amount",
      colSpan: 5,
      styles: {
        halign: "center",
        fontStyle: "bold",
        fillColor: [255, 250, 205], // Light yellow
      },
    },
    {
      content: `Rs. ${totalAmount.toLocaleString("en-IN")}`,
      styles: {
        fontStyle: "bold",
        textColor: [0, 0, 0],
        fillColor: [255, 250, 205],
      },
    },
  ]);

  // Create table
  doc.autoTable({
    startY: 20,
    head: [
      ["S.No", "Item Name", "Quantity", "Measure Units", "Description", "Amount"],
    ],
    body: tableData,
    styles: {
      lineWidth: 0.2,
      lineColor: "#B6B9CD",
      fontSize: 9,
    },
    headStyles: {
      fillColor: [63, 81, 181],
      textColor: [255, 255, 255],
      halign: "center",
    },
    bodyStyles: {
      halign: "center",
    },
    theme: "grid",
  });

  // Save PDF
  doc.save(`StockItems_Reports.pdf`);
  handleExportClose();
};


  const exportToJSON = () => {
    const jsonString = `data:text/json;charset=utf-8,${encodeURIComponent(
      JSON.stringify(filteredItems, null, 2)
    )}`;
    const link = document.createElement("a");
    link.href = jsonString;
    link.download = `StockItems_List.json`;
    link.click();
    handleExportClose();
  };


  return (
    <Card sx={{ marginTop: 10, marginRight: "15px", marginLeft: "15px" }}>
      <CardHeader
        title={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box display="flex" alignItems="center" mb={2}>
  <IconButton onClick={() => navigate(-1)} sx={{ color: "black", mr: 1 }}>
    <ArrowBackIcon />
  </IconButton>
  <Typography
    variant="h4"
    sx={{ fontWeight: "bold", textAlign: "left", color: "#333" }}
  >
    Stock Materials
  </Typography>
</Box>


            <Box display="flex" gap={2} alignItems="center">
              <Button
                variant="contained"
                startIcon={<PresentToAllIcon />}
                onClick={handleExportClick}
                sx={{
                  backgroundColor: "#3f51b5", // Custom background color
                  color: "white", // Text color
                  fontWeight: "bold", // Bold text
                  "&:hover": { backgroundColor: "#303f9f" }, // Darker shade on hover
                }}
              >
                Export
              </Button>

              <Menu
                anchorEl={exportAnchorEl}
                open={isExportMenuOpen}
                onClose={handleExportClose}
              >
                <MenuItem
                  onClick={exportToExcel}
                  sx={{
                    backgroundColor: "#f5f5f5", // Light background color
                    "&:hover": { backgroundColor: "#e0e0e0" }, // Hover effect
                  }}
                >
                  <ListItemIcon>
                    <SimCardDownloadIcon sx={{ color: "#388e3c" }} />
                  </ListItemIcon>{" "}
                  {/* Green icon for Excel */}
                  <ListItemText
                    primary="Excel"
                    sx={{ fontWeight: "bold", color: "#388e3c" }} // Text color and bold
                  />
                </MenuItem>

                <MenuItem
                  onClick={exportToPDF}
                  sx={{
                    backgroundColor: "#f5f5f5",
                    "&:hover": { backgroundColor: "#e0e0e0" },
                  }}
                >
                  <ListItemIcon>
                    <PictureAsPdfIcon sx={{ color: "#d32f2f" }} />
                  </ListItemIcon>{" "}
                  {/* Red icon for PDF */}
                  <ListItemText
                    primary="PDF"
                    sx={{ fontWeight: "bold", color: "#d32f2f" }} // Red text color
                  />
                </MenuItem>

                <MenuItem
                  onClick={exportToJSON}
                  sx={{
                    backgroundColor: "#f5f5f5",
                    "&:hover": { backgroundColor: "#e0e0e0" },
                  }}
                >
                  <ListItemIcon>
                    <FilePresentIcon sx={{ color: "#f57c00" }} />
                  </ListItemIcon>{" "}
                  {/* Orange icon for JSON */}
                  <ListItemText
                    primary="JSON"
                    sx={{ fontWeight: "bold", color: "#f57c00" }} // Orange text color
                  />
                </MenuItem>
              </Menu>
            </Box>
          </div>
        }
      />
      {/* <Grid item container alignItems="center" xs >
       
        <Typography variant="h3" sx={{paddingLeft:'10px',paddingTop:'5px',textAlign:'center'}}>
          Stock Items List
        </Typography>
      </Grid> */}
      <CardContent>
      <Box
  sx={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 2,
    mb: 2,
  }}
>
  {/* Left-side filters */}
  <Box sx={{ display: "flex", alignItems: "center", gap: 2, flexWrap: "wrap" }}>
    <TextField
      label="Search Items"
      variant="outlined"
      size="small"
      value={searchQuery}
      onChange={handleSearchChange}
    />

    {/* <FormControl variant="outlined" size="small" sx={{ minWidth: 150 }}>
      <InputLabel>Select Category</InputLabel>
      <Select
        label="Select Category"
        value={selectedCategory}
        onChange={handleCategoryChange}
      >
        <MenuItem value="">
          <em>None</em>
        </MenuItem>
        {categoryOptions.map((category, index) => (
          <MenuItem key={index} value={category}>
            {category}
          </MenuItem>
        ))}
      </Select>
    </FormControl> */}

   
  </Box>

  {/* Right-side button */}
  {/* <Button
    onClick={handleCreateNewItem}
    sx={{
      backgroundColor: "#3f51b5",
      color: "#fff",
      fontWeight: "bold",
      whiteSpace: "nowrap",
      "&:hover": { backgroundColor: "#303f9f" },
    }}
  >
    Create New Item
  </Button> */}
</Box>


        <GlobalStyles
          styles={{
            ".custom-sidebar-scrollbar": {
              scrollbarWidth: "thin", // For Firefox
              scrollbarColor: "grey #e0e0e0",
            },
            ".custom-sidebar-scrollbar::-webkit-scrollbar": {
              width: "6px", // For WebKit-based browsers
            },
            ".custom-sidebar-scrollbar::-webkit-scrollbar-track": {
              background: "#f1f1f1", // Track color
            },
            ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb": {
              backgroundColor: "grey", // Thumb color
              borderRadius: "10px",
            },
            ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "#555",
            },
          }}
        />

        <TableContainer
          component={Paper}
          style={{ maxHeight: "612px", overflowY: "auto" }}
          className="custom-sidebar-scrollbar"
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Sl.No
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Item Name
                </TableCell>
                {/* <TableCell style={{ fontWeight: 'bold', fontSize: '14px', color: '#000', border: "1px solid #ACB4AE", textAlign: 'center', backgroundColor: "#A1F4BD", }}>ITEM ID</TableCell> */}
                {/* <TableCell
                 sx={{
                  borderRight: "1px solid #ddd",
                  padding: "2px",
                  textAlign: "center",
                  backgroundColor: "#fff9c4",
                  fontWeight:'bold',
                  fontSize:'14px'
                }}
                >
                  HSN
                </TableCell> */}
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Quantity
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Measure Units
                </TableCell>
                {/* <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Category
                </TableCell> */}
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Description
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Price Per Item
                </TableCell>
                {/* <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Action
                </TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {isLoading ? (
                <TableRow>
                   <TableCell colSpan={9} style={{ textAlign: "center", padding: "20px" }}>
                                                                              <Box display="flex" flexDirection="column" alignItems="center">
                                                                                <CircularProgress />
                                                                                <Typography variant="body2" sx={{ mt: 1 }}>
                                                                                  Loading Data...
                                                                                </Typography>
                                                                              </Box>
                                                                            </TableCell>
                </TableRow>
              ) : filteredItems.length === 0 ? (
                <TableRow>
                  <TableCell
                    colSpan={9}
                    style={{ textAlign: "center", padding: "20px",fontSize:"15px" }}
                  >
                    No data available...
                  </TableCell>
                </TableRow>
              ) : (
                filteredItems.map((item, index) => (
                  <TableRow key={index}
                                      style={{
                                        backgroundColor: "white",
                                        transition: "background-color 0.3s",
                                        height: "40px", // Reduced row height
                                      }}
                                      onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = "#f5f5f5"; // Hover color
                                      }}
                                      onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = "white"; // Default color
                                      }}
                                      >
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {index + 1}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {item.items}
                    </TableCell>
                    {/* <TableCell sx={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center', fontSize: '15px' }}>{item.itId}</TableCell> */}
                    {/* <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {item.hsn}
                    </TableCell> */}
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {item.qty}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {item.measureUnits || "n/a"}
                    </TableCell>
                    {/* <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {item.category}
                    </TableCell> */}
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {item.description}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {item.priceItem}
                    </TableCell>

                    {/* <TableCell
  sx={{
    textAlign: "center",
    padding: "2px",
    borderRight: "1px solid #d6d6d6",
  }}
>
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      gap: "6px",
    }}
  >
    {/* <Button
      variant="contained"
      size="small"
      startIcon={<EditIcon />}
      onClick={() => handleOpen(item)}
      sx={{
        fontSize: "12px",
        padding: "4px 8px",
        backgroundColor: "#1565c0",
        color: "white",
        "&:hover": {
          backgroundColor: "#0d47a1",
        },
      }}
    >
      Edit
    </Button> 

    <Button
      variant="contained"
      size="small"
      color="error"
      startIcon={
        deletingItemId === item.itId ? null : <DeleteIcon />
      }
      onClick={() => handleDelete(item)}
      disabled={deletingItemId === item.itId}
      sx={{
        fontSize: "12px",
        padding: "4px 8px",
        backgroundColor: "#a82814",
        color: "white",
        "&:hover": {
          backgroundColor: "#7a1b0e",
        },
      }}
    >
      {deletingItemId === item.itId ? "Deleting..." : "Delete"}
    </Button>
  </Box>
</TableCell> */}

                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <ToastContainer />
      </CardContent>

    </Card>
  );
};

export default StockItemsMaterialReports;